export default {"src":"/_next/static/media/check-green.21d574d9.svg","height":32,"width":32};